import WhiteTickIcon from "@/assets/FFFFFF_tick_icon.svg?react";
import RefluencedLogoSrc from "@/assets/refluenced_icon.svg";
import GreyCompanyIcon from "@/assets/registration/C1C1D7_company_icon.svg?react";
import GreyInfoIcon from "@/assets/registration/C1C1D7_info_icon.svg?react";
import BackIcon from "@/assets/registration/C4CBFE_back_arrow_icon.svg?react";
import WhiteCompanyIcon from "@/assets/registration/FFFFFF_company_icon.svg?react";
import WhiteInfoIcon from "@/assets/registration/FFFFFF_info_icon.svg?react";
import WhiteProfile from "@/assets/registration/FFFFFF_profile_icon.svg?react";
import Button from "@/components/Common/Button";
import clsxm from "@/lib/clsxm";
import useRegistrationStore from "@/store/registration";
import {useCallback, useMemo, type FC} from "react";

const RegistrationTopView: FC<{isRefluencedLogoVisible?: boolean}> = ({isRefluencedLogoVisible = true}) => {
  const step = useRegistrationStore(state => state.step);
  const isCredentialsStepValidated = useRegistrationStore(state => state.stepValidations.credentials);
  const isCompanyDetailsStepValidated = useRegistrationStore(state => state.stepValidations.company_details);
  const validateCredentials = useRegistrationStore(state => state.validateCredentials);
  const validateCompanyDetails = useRegistrationStore(state => state.validateCompanyDetails);
  const setValue = useRegistrationStore(state => state.setValue);

  const goBack = useCallback(() => {
    if (step === "company_details") {
      setValue("step", "credentials");
    } else if (step === "interest_selection") {
      setValue("step", "company_details");
    }
  }, [step, setValue, validateCompanyDetails]);
  const goToNextPage = useRegistrationStore(state => state.goToNextPage);

  const shouldShowForwardButton = useMemo(() => {
    if (step === "credentials") {
      return isCredentialsStepValidated;
    } else if (step === "company_details") {
      return isCompanyDetailsStepValidated;
    }
    return false;
  }, [step, isCredentialsStepValidated, isCompanyDetailsStepValidated]);

  return (
    <div className="flex w-full flex-col items-center gap-10">
      <div className="flex w-full justify-between">
        {step !== "credentials" ? (
          <button onClick={goBack}>
            <BackIcon className="size-4 shrink-0" />
          </button>
        ) : (
          <div className="w-[17px]" />
        )}
        <div className="flex items-center justify-center gap-3">
          <Button
            onClick={() => setValue("step", "credentials")}
            className={
              "flex h-10 w-10 items-center justify-center rounded-full border transition-all duration-150 " +
              (step === "credentials"
                ? "border-primary-medium-solid bg-primary-dark-solid"
                : "border-success-light-green bg-success-herbal")
            }>
            {step === "credentials" && !isCredentialsStepValidated ? (
              <WhiteProfile className="size-5 shrink-0 pr-px" />
            ) : (
              <WhiteTickIcon className="size-5 shrink-0" />
            )}
          </Button>
          <div
            className={
              "h-0.5 w-4 rounded-full transition-all duration-150 " +
              (step === "credentials"
                ? "bg-neutral-grey-light"
                : step === "company_details"
                  ? "bg-primary-dark-solid"
                  : "bg-success-herbal")
            }
          />
          <Button
            isDisabled={!isCredentialsStepValidated}
            onClick={() => validateCredentials() && setValue("step", "company_details")}
            className={clsxm(
              "flex h-10 w-10 items-center justify-center rounded-full border transition-all duration-150 disabled:cursor-not-allowed disabled:active:scale-100",
              step === "company_details" ? "border-primary-medium-solid bg-primary-dark-solid" : "",
              step === "interest_selection" || (isCompanyDetailsStepValidated && step !== "company_details")
                ? "border-success-light-green bg-success-herbal"
                : "",
              step === "credentials" && !isCompanyDetailsStepValidated
                ? "border-neutral-grey-light bg-primary-light-solid"
                : "",
            )}>
            {step === "company_details" && !isCompanyDetailsStepValidated ? (
              <WhiteCompanyIcon className="size-5 shrink-0" />
            ) : step === "interest_selection" || isCompanyDetailsStepValidated ? (
              <WhiteTickIcon className="size-5 shrink-0" />
            ) : (
              <GreyCompanyIcon className="size-5 shrink-0" />
            )}
          </Button>
          <div
            className={
              "h-0.5 w-4 rounded-full transition-all duration-150 " +
              (step !== "interest_selection" ? "bg-neutral-grey-light" : "bg-primary-dark-solid")
            }
          />
          <Button
            isDisabled={!isCredentialsStepValidated || !isCompanyDetailsStepValidated}
            onClick={() => validateCompanyDetails() && validateCredentials() && setValue("step", "interest_selection")}
            className={
              "flex h-10 w-10 items-center justify-center rounded-full border transition-all duration-150 disabled:cursor-not-allowed disabled:active:scale-100 " +
              (step === "interest_selection"
                ? "border-primary-medium-solid bg-primary-dark-solid"
                : "border-neutral-grey-light bg-primary-light-solid")
            }>
            {step === "interest_selection" ? (
              <WhiteInfoIcon className="size-5 shrink-0" />
            ) : (
              <GreyInfoIcon className="size-5 shrink-0" />
            )}
          </Button>
        </div>
        {shouldShowForwardButton ? (
          <button onClick={goToNextPage}>
            <BackIcon className="size-4 shrink-0 rotate-180" />
          </button>
        ) : (
          <div className="w-[17px]" />
        )}
      </div>
      {isRefluencedLogoVisible && (
        <div className="size-20 shrink-0">
          <img src={RefluencedLogoSrc} className="size-full object-contain" />
        </div>
      )}
    </div>
  );
};

export default RegistrationTopView;
